const $ = jQuery;

const newHeaderMenu = document.querySelector("#methodme-theme-header  .methodme-main-menu ");
if (newHeaderMenu) {
	const allMenuWithSub = newHeaderMenu.querySelectorAll(" #methodme-theme-header  .methodme-main-menu > .menu-item-has-children");
	document.addEventListener("click", (e) => {
		if (!e.target.closest("#methodme-theme-header  .methodme-main-menu .menu-item-has-children")) {
			allMenuWithSub.forEach((menu) => menu.classList.remove("active"));
			return;
		}
	});

	allMenuWithSub.forEach((menu) => {
		menu.addEventListener("click", (e) => {
			if (e.target.getAttribute("href") == "#" || e.target.getAttribute("href") == "") e.preventDefault();
			// e.preventDefault();
			Array.from(allMenuWithSub)
				.filter((menuItem) => menuItem !== menu)
				.forEach((item) => item.classList.remove("active"));
			if (e.target.closest(".menu-item-has-children") == menu) {
				if (!e.target.classList.contains("dropdown-toggler")) {
					return;
				}
				menu.classList.toggle("active");
			}
		});
	});
}

/**
 * Instantiate Foundation for Mobile Menu
 */
$(document).foundation();
